import { createQueryKeys } from '@lukemorales/query-key-factory';

export const auth = createQueryKeys('auth', {
  changeLocale: null,
  completePersonalData: null,
  completeUserRegistration: null,
  loginUser: null,
  logoutUser: null,
  setNewUserPassword: null,
  signUpUser: null,
  verifyEmail: null,
  verifyPhoneNumber: null,
  requestVerificationCode: null,
});
